import { render } from "./KnowMoreComponent.vue?vue&type=template&id=237346b8"
import script from "./KnowMoreComponent.vue?vue&type=script&lang=js"
export * from "./KnowMoreComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__